<template>
    <div id="grid">
        <div class="images">
            <img class="planet-image" :style="cssAttrs" :src="planetImageUrl" />
            <img v-if="selectedTab === 'geology'" class="surface-image" :src="surfaceImageUrl"/>
        </div>                
        <div class="description">
            <h1>{{ planetName }}</h1>
            <div class="text-description">
                <p>{{ planet[selectedTab].content }}</p>
                <p class="link">Source: <a :href="planet[selectedTab].source" target="blank">Wikipedia</a><font-awesome-icon icon="fa-solid fa-square-arrow-up-right" size="lg"/></p>
            </div>
        </div> 
        <div class="tabs">
            <ul>
                <li v-for="(tab, idx) in tabs" :key="tab" :ref="tab">
                    <base-button
                        :color="planet.color"
                        :isActive="selectedTab===tab"
                        :num="idx+1"
                        :tabCaption="tab"
                        :tabId="tab"    
                        @on-click="selectTab">
                    </base-button>
                </li>
            </ul>
            <hr v-if="isSmallScreen">  
        </div>       
                     
        <ul class="facts-list">
            <li v-for="fact in planet.facts" :key="fact.name">
                <base-card :name="fact.name" :value="fact.value"></base-card>
            </li>
        </ul>
    </div>
   
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from './BaseButton.vue';
import BaseCard from './BaseCard.vue';
export default {
    components: {
        BaseButton,
        BaseCard
    },
    props: ['planetId'],
    data() {
        return {
            selectedTab: 'overview',
            tabs: ['overview', 'structure', 'geology']
        };
    },
    computed: {
        ...mapGetters(['isSmallScreen', 'planetsData', 'screenWidth']),
        cssAttrs() {
            return {
                '--scale': this.planet['scale']
            };
        },

        planet () {
            return this.planetsData[this.planetId]
        },
       
        planetName() {
            return this.planet.name;
        },

        planetImageUrl() {
            return this.planet[this.selectedTab].image;
        },
        
        surfaceImageUrl() {
            return this.planet[this.selectedTab].image_surface;
        }
    },
    watch: {
        planetId () {
            this.selectedTab = 'overview';
            this.focusSelectedTab();
        }
    },
    mounted() {
        this.focusSelectedTab();
    },

    methods: {
        focusSelectedTab() {
            this.$refs[this.selectedTab][0].firstChild.focus();
        },
        selectTab(tab) {
            this.selectedTab = tab;
        }
         
    }
}
</script>

<style scoped>
#grid {
    height: 90vh;
    width: 80%;
    max-width: 1400px;   
    margin: auto;
     
    display: grid;
    grid-column-gap: 20px;
    grid-template-columns: 2fr 1fr;
    grid-template-areas: 
        "img desc"
        "img tabs"
        "facts facts";    
}

ul {
    list-style: none;
}

h1 {
    font-size: 80px;
    font-weight: 500;
    line-height: 103px;
}

p {
    font-family: "Spartan", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
}

p.link {
    color: #838391;
}

a {
    font-weight: bold;
    color: #838391;
}


hr {
    height: 1px;
    margin: 0;
    border: none;
    border-top: solid 1px #838391;
}

.images {
    padding: 30px 0;
    grid-area: img;
    place-self: center center;
}

.description {
    grid-area: desc;
    place-self: end end;
}

.tabs {
    grid-area: tabs;
    place-self: start end;
}

.tabs ul {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 176px;
    padding: 0;
}

ul.facts-list {
    grid-area: facts;
    display: flex;
    flex-shrink: 1;
    justify-content: space-between;
    align-items: center;
    padding: 0;
}

div.text-description p {
    width: 350px;
}

img.source-icon {   
    height: 12px;
    width: 12px;
    vertical-align: middle;
}

div.images,
img.planet-image {
    position: relative;
    height: auto;
    width: calc(clamp(256px, 35vw, 668px) * var(--scale));
}

img.surface-image {
    position: absolute;
    top: 65%;
    left: 0;
    right: 0;
    margin: auto;
    width: clamp(64px, 12vw, 163px);
    aspect-ratio: 163 / 199;
}


@media screen and (max-width: 1199px){
    p {
        font-size: 11px;
        line-height: 22px;
        letter-spacing: 0;
    }
}

@media screen and (max-width: 767px) {
    #grid {
        width: 100%;
        grid-template-areas: 
            "tabs tabs"
            "img img"
            "desc desc"
            "facts facts";
    }

    .tabs {
        height: 52px;
        width: 100%;
    }

    .tabs ul{
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        height: 100%;
        margin: 0;
    }

    .tabs li {
        height: 100%;
    }

    .description {
        text-align: center;
        place-self: center center;
    }

    h1 {
        font-size: 40px;
    }

    ul.facts-list {
        flex-direction: column;
    }
}

@media screen and (min-width: 768px) and (max-width: 1199px){
    #grid {
        width: 90%;
        grid-template-areas: 
            "img img"
            "desc tabs"
            "facts facts";
    }

    h1 {
        font-size: 48px;
    }

    .description {
        place-self: center start;
    }

    .tabs {
        place-self: center end;
    }
}
</style>